export default __webpack_public_path__ + "static/media/contact-sm.39fd0573.png";